<template>
  <el-dialog
   class="dialog-form"
   title="设备配置"
   :visible="soilDialog"
   width='580px'
   :close-on-click-modal='false'
   :show-close="true"
   @close='closeDialog'
   max-height="550">
   <el-form ref="form" class="global-form" :model="soilInfo" :rules="rules" label-position="left" label-width="170px">
     <el-form-item prop="maintType" label="所属物种">
       <el-select v-model="soilInfo.maintType">
         <el-option v-for="item in typeList" :key="item.dicCode" :label="item.dicValue" :value="item.dicCode"></el-option>
       </el-select>
     </el-form-item>
     <el-form-item prop="depth" label="距离地面深度(CM)">
       <el-input type="number" v-model="soilInfo.depth" placeholder="请输入距离地面深度"/>
     </el-form-item>
     <el-form-item prop="drought" label="土壤湿度干旱阈值(%)">
       <el-input type="number" v-model="soilInfo.drought" placeholder="请输入土壤湿度干旱阈值"/>
     </el-form-item>
     <el-form-item prop="saturated" label="土壤湿度饱和阈值(%)">
       <el-input type="number" v-model="soilInfo.saturated" placeholder="请输入土壤湿度饱和阈值"/>
     </el-form-item>
     <el-form-item prop="frozen" label="土壤温度冰冻阈值(℃)">
       <el-input type="number" v-model="soilInfo.frozen" placeholder="请输入土壤温度冰冻阈值"/>
     </el-form-item>
     <el-form-item prop="overheated" label="土壤温度过热阈值(℃)">
       <el-input type="number" v-model="soilInfo.overheated" placeholder="请输入土壤温度过热阈值"/>
     </el-form-item>
     <!-- 氮磷钾ORP -->
     <el-form-item prop="nitrogenLowerLimit" label="氮含量偏低(mg/kg)">
       <el-input type="number" v-model="soilInfo.nitrogenLowerLimit" placeholder="请输入氮含量偏低阈值"/>
     </el-form-item>
     <el-form-item prop="nitrogenUpperLimit" label="氮含量偏高(mg/kg)">
       <el-input type="number" v-model="soilInfo.nitrogenUpperLimit" placeholder="请输入氮含量偏高阈值"/>
     </el-form-item>
     <el-form-item prop="phosphorusLowerLimit" label="磷含量偏低(mg/kg)">
       <el-input type="number" v-model="soilInfo.phosphorusLowerLimit" placeholder="请输入磷含量偏低阈值"/>
     </el-form-item>
     <el-form-item prop="phosphorusUpperLimit" label="磷含量偏高(mg/kg)">
       <el-input type="number" v-model="soilInfo.phosphorusUpperLimit" placeholder="请输入磷含量偏高阈值"/>
     </el-form-item>
     <el-form-item prop="potassiumLowerLimit" label="钾含量偏低(mg/kg)">
       <el-input type="number" v-model="soilInfo.potassiumLowerLimit" placeholder="请输入钾含量偏低阈值"/>
     </el-form-item>
     <el-form-item prop="potassiumUpperLimit" label="钾含量偏高(mg/kg)">
       <el-input type="number" v-model="soilInfo.potassiumUpperLimit" placeholder="请输入钾含量偏高阈值"/>
     </el-form-item>
     <el-form-item prop="orpLowerLimit" label="ORP值偏低(mV)">
       <el-input type="number" v-model="soilInfo.orpLowerLimit" placeholder="请输入ORP值偏低阈值"/>
     </el-form-item>
     <el-form-item prop="orpUpperLimit" label="ORP值偏高(mV)">
       <el-input type="number" v-model="soilInfo.orpUpperLimit" placeholder="请输入ORP值偏高阈值"/>
     </el-form-item>
   </el-form>
   <el-button :loading="loading" type="primary" @click="submit">保存</el-button>
 </el-dialog>
</template>

<script>
import { integerWithin, validNumberOne, validNumberThree, validNumberFour } from '@/utils/validate'
export default {
  name: 'setting',
  props: {
    soilDialog: {
      type: Boolean,
      default: false
    },
    deviceNumber: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      projectId: '',
      soilInfo: {
        maintType: '',
        maintTypeName: '',
        depth: '',
        drought: '',
        saturated: '',
        frozen: '',
        overheated: '',
        // 氮磷钾ORP
        nitrogenUpperLimit: '',
        nitrogenLowerLimit: '',
        phosphorusUpperLimit: '',
        phosphorusLowerLimit: '',
        potassiumUpperLimit: '',
        potassiumLowerLimit: '',
        orpLowerLimit: '',
        orpUpperLimit: ''
      },
      species: [],
      typeList: [],
      rules: {
        maintType: [{ required: true, message: '请选择养护物种', trigger: 'change' }], // 养护物种编号
        depth: [{ required: true, message: '请输入距离地面深度', trigger: 'blur' }], // 距离地面深度/CM
        drought: [
          { required: true, message: '请输入土壤湿度干旱阈值', trigger: 'blur' },
          { validator: integerWithin, trigger: ['blur', 'change'] }
        ], // 土壤湿度干旱阈值/%
        saturated: [
          { required: true, message: '请输入土壤湿度饱和阈值', trigger: 'blur' },
          { validator: integerWithin, trigger: ['blur', 'change'] }
        ], // 土壤湿度饱和阈值/%
        frozen: [
          { required: true, message: '请输入土壤温度冰冻阈值', trigger: 'blur' },
          { validator: validNumberOne, trigger: ['blur', 'change'] }
        ], // 土壤温度冰冻阈值/℃
        overheated: [
          { required: true, message: '请输入土壤温度过热阈值', trigger: 'blur' },
          { validator: validNumberOne, trigger: ['blur', 'change'] }
        ], // 土壤温度过热阈值/℃
        nitrogenLowerLimit: [
          { required: true, message: '请输入氮含量偏低阈值', trigger: 'blur' },
          { validator: validNumberThree, trigger: ['blur', 'change'] }
        ],
        nitrogenUpperLimit: [
          { required: true, message: '请输入氮含量偏高阈值', trigger: 'blur' },
          { validator: validNumberThree, trigger: ['blur', 'change'] }
        ],
        phosphorusLowerLimit: [
          { required: true, message: '请输入磷含量偏低阈值', trigger: 'blur' },
          { validator: validNumberThree, trigger: ['blur', 'change'] }
        ],
        phosphorusUpperLimit: [
          { required: true, message: '请输入磷含量偏高阈值', trigger: 'blur' },
          { validator: validNumberThree, trigger: ['blur', 'change'] }
        ],
        potassiumLowerLimit: [
          { required: true, message: '请输入钾含量偏低阈值', trigger: 'blur' },
          { validator: validNumberThree, trigger: ['blur', 'change'] }
        ],
        potassiumUpperLimit: [
          { required: true, message: '请输入钾含量偏高阈值', trigger: 'blur' },
          { validator: validNumberThree, trigger: ['blur', 'change'] }
        ],
        orpLowerLimit: [
          { required: true, message: '请输入ORP值偏低阈值', trigger: 'blur' },
          { validator: validNumberFour, trigger: ['blur', 'change'] }
        ],
        orpUpperLimit: [
          { required: true, message: '请输入ORP值偏高阈值', trigger: 'blur' },
          { validator: validNumberFour, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
    deviceNumber () {
      if (this.deviceNumber.length === 1) {
        this.loadData()
      }
      this.getTypeList()
    }
  },
  created () {
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.iot.selectSoilInfoByDeviceNumber, {
        deviceNumber: this.deviceNumber[0]
      }).then(res => {
        this.soilInfo = res || {}
      })
    },
    getTypeList () {
      this.$axios.get(this.$apis.system.selectDicByList, { dicType: 'maintType' }).then(res => {
        this.typeList = res.maintType || []
      })
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const query = {
            deviceNumber: this.deviceNumber,
            soilInfo: this.soilInfo
          }
          if (query.soilInfo.maintTypeName) {
            delete query.soilInfo.maintTypeName
          }
          this.loading = true
          this.$axios.post(this.$apis.iot.updateSoilInfoConf, query).then(() => {
            this.$message({ message: '保存成功', type: 'success' })
            this.$emit('getData')
            this.closeDialog()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
